import React from 'react';
import { Spinner, Container } from 'react-bootstrap';

const LoadingSpinner = ({ fullPage = true }) => {
  if (fullPage) {
    return (
      <Container className="d-flex justify-content-center align-items-center" style={{ minHeight: '80vh' }}>
        <div className="text-center">
          <Spinner animation="border" variant="primary" style={{ width: '3rem', height: '3rem' }} />
          <p className="mt-3">Wird geladen...</p>
        </div>
      </Container>
    );
  }
  
  return (
    <div className="text-center p-4">
      <Spinner animation="border" variant="primary" />
    </div>
  );
};

export default LoadingSpinner;